import { Html } from "@react-three/drei";
import { useState } from "react";

export default function Meshpoint(props) {
    {/* -------------------------------- Handling Hovering Salon-------------------------------- */ }
    const [isMeshHovered, setIsMeshHovered] = useState(false);
    const HandleHoverMeshIn = () => {
        setIsMeshHovered(true);
    };
    const HandleHoverMeshOut = () => {
        setIsMeshHovered(false);
    };
    {/* --------------------------- Fin Handling Hovering salon --------------------------- */ }


    { /* ---------------------------- Handling Salon  texture choice ---------------------------- */ }


    const meshTexture1Handler = () => {
        {/**Grat texture */ }
        props.meshRef.current.material.map = props.meshTexture2;
    };

    const meshTexture2Handler = () => {
        {/**Brown texture */ }
        props.meshRef.current.material.map = props.meshTexture1;
    };

    return <Html wrapperClass="block-wrapper" position={props.position}>
        <div
            className="box-hover"
            onPointerOver={HandleHoverMeshIn}
            onPointerOut={HandleHoverMeshOut}
        >
            <div className="textures-container">
                <div>
                    <div className={`textures ${isMeshHovered ? "active" : ""}`}>
                        <div
                            onClick={meshTexture2Handler}
                            className={`texture ${props.classNameTexture1}`}
                        ></div>
                        <div
                            onClick={meshTexture1Handler}
                            className={`texture ${props.classNameTexture2}`}
                        ></div>
                    </div>
                </div>
            </div>
            <div className="wrapper-pulsar">
                <div className="wave"></div>
            </div>
        </div>
    </Html>
}
